import React from "react";
import {
  Button,
  Row, Col,
  Input, Label,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import InputText from '../FormParts/InputText';
import { getErrorCodes } from "../../variables/message";
import Validate from "../../common/Validate";

export default class AddMemoPopupInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        data: this.props.rootData.data,
        modal: this.props.rootData.modal,
        // 親コンポーネントの関数（ここでは結果を引数として渡し、処理は親側で実行する）
        updateMemo: this.props.rootData.updateMemo,
        updateMemoSupplier: this.props.rootData.updateMemoSupplier,
        supplierFlag: typeof this.props.rootData.updateMemoSupplier === 'function',
        // ダイアログの閉じる（×）ボタンの表示有無
        closeCrossButton: this.props.unnecessaryCloseCrossButton ? false : true,
        // コメントの0文字検証有無
        requiredComment: this.props.allowEmptyComment ? false : true
    };
    this.toggleModal = this.props.toggleModal.bind(this)
    this.validateCallBack = this.validateCallBack.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      console.log(this.props.data.values)
      this.setState({
        data: {
          ...this.props.data,
          values : {
            ...this.props.data.values,
            add_memo: "",
            add_supplier_memo: "",
          },
          errors : {}
        }
      })
    }
  }

  validateCallBack(newData, callback = () => { }) {
    const data = this.state.data;
    this.setState({
      data: {
        ...data,
        ...newData
      }
    }, () => callback())
  }

  show() {
    this.setState({ modal: true });
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true
  }

  render() {
    const memo =  this.state.data.isOrderMemo ? this.state.data.values.order_memo : this.state.data.values.supplier_memo
    return (
      <>
        <ModalBody>
          <Row>
            <Col className={this.props.className}>
              { this.state.closeCrossButton &&
                <button type="button" className="close modal-close" data-dismiss="modal" aria-label="Close" onClick={() => this.toggleModal()}>
                  <i className="tim-icons icon-simple-remove"></i>
                </button>
              }
              <Label for={this.state.data.label}>{this.state.data.label}:</Label>
              <Input
                name={this.state.data.isOrderMemo ? "ESTIMATE__order_memo" : "ESTIMATE__supplier_memo"}
                type={"textarea"}
                value={memo || ""}
                disabled={true}
                className="modal-upper-memo"
              />
            </Col>
          </Row>
          <Row style={{marginTop:"20px"}}>
            <Col md="12" className={this.props.className}>
              <InputText
                name={this.state.supplierFlag ? "TEMP__add_supplier_memo": "TEMP__add_memo"}
                label='コメント'
                labelOn={true}
                validateCallback={this.validateCallBack}
                multiline={true}
                rootData={this.state.data}
                validateType='regist'
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button style={{ margin: '0 auto' }} color="" onClick={this.toggleModal}>
            {this.props.negativeButtonName ? this.props.negativeButtonName: "キャンセル"}
          </Button>
          <Button style={{ margin: '0 auto' }} color="info"
            onClick={() => {
              let current_memo = this.state.isOrderMemo ?  this.state.data.values.order_memo : this.state.data.values.supplier_memo;              
              current_memo = current_memo === null ? "" : current_memo
              const memo = this.state.data.isOrderMemo ? this.state.data.values.add_memo ? this.state.data.values.add_memo : "" : this.state.supplierFlag ? this.state.data.values.add_supplier_memo ? this.state.data.values.add_supplier_memo : "" : this.state.data.values.add_memo
              if(this.validate()){
                if(this.state.requiredComment){
                  // 必須(空白文字にも対応)
                  const rx = new RegExp("^\\s+$");
                  const min_length_validate = memo.length === 0 || rx.test(memo)
                  if(min_length_validate){
                    this.props.alertModal.current.showErrorModal({messageNo:2024});
                    return;
                  }
                }

                // 無効な文字列
                const max_length_validate = Validate.length(current_memo + memo, "", "text_ja_20000")
                if(!max_length_validate.valid){
                  this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
                  return;
                }
                this.state.data.isOrderMemo ? this.state.updateMemo(this.state.data.values,this.state.data.isOrderMemo): this.state.supplierFlag ? this.state.updateMemoSupplier(this.state.data.values): this.state.updateMemo(this.state.data.values,this.state.data.isOrderMemo);
                this.toggleModal();
              }
            }}>
            {this.props.positiveButtonName ? this.props.positiveButtonName : "更新する"}
          </Button>
        </ModalFooter>
      </>
    )
  }
}
